package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.project.ProjectConfiguration
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable

@Serializable
data class FinishingUp(
  override val uuid: NativeUuid,
  override val projectId: ProjectConfiguration.PhotovoltaicsProjectId,
  val checklist: Checklist = Checklist.empty,
) : ProjectStump {

  @Serializable
  data class Checklist(
    val zaehlertauschInExcelEingetragen: Boolean = false,
    val streitbemerkungEingepflegt: Boolean = false,
    val teamsOneDriveDatenHeruntergeladen: Boolean = false,
    val bestelllisteAktualisiert: Boolean = false,
    val monitoringKontrolliert: Boolean = false,
    val marktstammdatenregistrierungErledigt: Boolean = false,
    val smaGarantieRegistriert: Boolean = false,
    val fertigmeldungAnNetzbetreiberVersendet: Boolean = false,
    val uebergabeplanErstelltUndAbgelegt: Boolean = false,
  ) {
    val isNotEmpty: Boolean
      get() = zaehlertauschInExcelEingetragen ||
        streitbemerkungEingepflegt ||
        teamsOneDriveDatenHeruntergeladen ||
        bestelllisteAktualisiert ||
        monitoringKontrolliert ||
        marktstammdatenregistrierungErledigt ||
        smaGarantieRegistriert ||
        fertigmeldungAnNetzbetreiberVersendet ||
        uebergabeplanErstelltUndAbgelegt

    companion object {
      val empty: Checklist
        get() = Checklist()
    }
  }
}
